export class DeskMessage{
    public from: string;
    public to: string;
    public msg: string;
    public from_name: string;
    public hour: string;
    public type: string;
    public office_name: string;
  }
